import React from 'react';
import { FormikValues, useField, useFormikContext } from 'formik';
import { TextAreaProps } from 'antd/lib/input';
import TextArea from 'antd/lib/input/TextArea';
import { useFormikFormContext } from '../FormikFormContext';
import { IExtraInputProps, useInputProps } from '../hooks/useInputProps';

// interface Props<T extends FormikValues> extends Omit<TextAreaProps, 'name'> {
//   name: keyof T & string;
// }
export interface TextAreaInputProps<T extends FormikValues>
  extends Omit<TextAreaProps, 'name'>,
    IExtraInputProps {
  name: keyof T & string;
}

/**
 * Campo per input area di testo.
 */
export function TextAreaInput<T extends FormikValues>(
  props: TextAreaInputProps<T>
) {
  const { name, extraOptions, ...otherProps } = props;
  const [field, meta] = useField(name);
  const inputProps = useInputProps(props);

  return <TextArea {...field} {...otherProps} {...inputProps} />;
}
